import ComplaintDate from './ComplaintDate'

export default ComplaintDate
